import './Alexandra.css';
import eagleImg from '../../assets/images/alex_eagle.jpg';
import tourImg from '../../assets/images/alex_tour.jpg';
import abschlussImg from '../../assets/images/alex_abschluss.png.jpeg';

function Alexandra() {
  return (
    <section id="alexandra" className="alexandra">
      <div className="alexandra__inner">

        <div className="alexandra__header">
          <span className="alexandra__label">Pâtisserie &amp; Konditorenkunst</span>
          <h2 className="alexandra__title">Alexandra Wende</h2>
          <div className="alexandra__divider" />
        </div>

        <div className="alexandra__layout">
          <div className="alexandra__images">
            <div className="alexandra__img-main">
              <img src={eagleImg} alt="Alexandra Wende" className="alexandra__img" />
            </div>
            <div className="alexandra__img-grid">
              <div className="alexandra__img-wrap">
                <img src={tourImg} alt="Alexandra Wende – Tour" className="alexandra__img" />
              </div>
              <div className="alexandra__img-wrap">
                <img src={abschlussImg} alt="Alexandra Wende – Abschluss" className="alexandra__img" />
              </div>
            </div>
          </div>

          <div className="alexandra__content">
            <p className="alexandra__text">
              Alexandra Wende – ausgebildet an der renommierten Pariser Gastronomieschule Le Cordon Bleu.
            </p>
            <p className="alexandra__text">
              Abschluss im Mai 2014 mit dem großen Diplom der „Haute Cuisine" und der „Pâtisserie" als
              Jahrgangs­beste und mit der besonderen Auszeichnung „mention bien".
            </p>
            <p className="alexandra__text">
              Es folgte die Mitarbeit im LAZARE (Bistro des Jahres 2015 von Chef Eric Frechon) und in der
              Pâtisserie de Cyril Lignac, Paris sowie weitere Fortbildungen zur klassischen französischen
              Pâtisserie an der bedeutenden Gastronomieschule Ferrandi, Paris.
            </p>
            <p className="alexandra__text">
              Nach ihrer Rückkehr nach Düsseldorf, im Sommer 2015, und dem erfolgreichen Ablegen der
              deutschen Konditoren-Meisterprüfung vor der HWK zu Köln im Januar 2016, freut sich
              Alexandra Wende nun, ihre eigene Pâtisserie im Herzen von Düsseldorf führen zu dürfen.
            </p>
            <p className="alexandra__text">
              Für Alexandra Wende ist Nachhaltigkeit und der bewusste und respektvolle Umgang mit
              Rohstoffen sehr wichtig. Saisonale und regionale Produkte werden bevorzugt, industriell
              hergestellte Rohstoffe – besonders aus tierischer Produktion – werden konsequent abgelehnt
              und durch tier- und umweltschonende Alternativen mehr als ersetzt. Dieser Ansatz sichert
              ein feinstes Geschmackserlebnis – natürlich – im schönsten Gewand.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Alexandra;
